export default "__VITE_ASSET__C1z25ZBJ__"